//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { NO_GALLERIES_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { createAction } from '@utils/actions';

const openModal = () => {
  return createAction({
    type: NO_GALLERIES_MODAL_ACTIONS.OPEN_MODAL,
  });
};

const closeModal = () => {
  return createAction({
    type: NO_GALLERIES_MODAL_ACTIONS.CLOSE_MODAL,
  });
};

export type NoGalleriesModalAction = ReturnType<
  typeof openModal | typeof closeModal
>;

export const noGalleriesModalActions = {
  openModal,
  closeModal,
};
